import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { HospitalityContent } from '@/pageContents/hospitality/HospitalityContent';
import { Permission } from '@/models/user';

const EditPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Hospitality Bearbeiten | Starjack Backoffice</Helmet>

            <HospitalityContent newOrEditMode={true} />
        </>
    );
};

EditPage.isProtected = true;
EditPage.permissions = [Permission.HOSPITALITY_NAV];
EditPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default EditPage;
